import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { SafeHtmlPipe } from "../shared/safe-html/safe-html";

@Component({
  selector: 'app-e-posta-dogrulama',
  standalone: true,
  imports: [TohumUiModule, SafeHtmlPipe],
  templateUrl: './e-posta-dogrulama.component.html',
  styleUrls: ['./e-posta-dogrulama.component.scss']
})
export class EPostaDogrulamaComponent implements OnInit {

  basvuruTuru: string;
  basvuruId: string;
  ePosta: string;
  onayKodu: string;

  hataVarMi: boolean = false;
  hataMesaji: string;

  constructor(private route: ActivatedRoute, private router: Router, private funcs: FuncsService) {
    this.route.params.subscribe((params: Params) => {
      this.basvuruTuru = params.basvuruTuru;
      this.basvuruId = params.basvuruId;
      this.ePosta = params.ePosta;
      this.onayKodu = params.onayKodu;
    });
  }

  ngOnInit(): void {
  }

  bilgiGetirmedeHataAlindi(event: any) {
    this.hataVarMi = true;
    this.hataMesaji = event.json.detail.messages[0].message;
  }

  anaSayfayaGit() {
    this.router.navigateByUrl('/');
  }

  login() {
    this.router.navigateByUrl('');
  }

  ePostaOnayKoduGonderildi() {
    this.funcs.basariliMesajiVer('Mail başarıyla gönderildi. Gönderilen mail in tarafınıza iletilmesi bir kaç dakika sürebilir.');
    this.router.navigateByUrl('/');
  }

  ePostaOnayKoduGonderimdeHataAlindi(event: any) {
    this.funcs.hataMesajiVerUi('Mail gönderimi BAŞARISIZ. (HATA: ' + event.json.detail.messages[0].message + ')');
  }

}
